const listMap = [
    {
        keys: new Set(["sithMesStoolPr",
            'sithMesStoolPrPrice',
            'sithMesStoolPo',
            'sithMesStoolPoSdr',
            'sithMesQualityInspectTask-sithMesQualityInspectTaskIncomingVo',
            'sithMesInventoryReceiptReturnRecord',
            'sithMesMstMaterial-sithMesMstMaterialBasicVo',
        ]),
        columns: [
            {
                key: 'eclassInfo',
                label: 'EClass Info',
                sortable: false,
                form: {
                    type: 'input',
                    modalMultiSelectedType: 'string'
                }
            },
        ]
    }
];

export function _getAdditionColumnsByKey(entity, key) {
    //console.log('#getting addition columns: ', entity, key);
    for (let map of listMap) {
        if (map.keys.has(entity) || map.keys.has(entity + '-' + key)) {
            return map.columns;
        }
    }
    return null;
}
